/** Leaves the app for an Auth0-hosted page (VIS-441). Its own module so tests can replace it. */
export function leaveAppFor(url: string) {
  window.location.assign(url)
}
